<template>
  <div class="chart-container">
    <v-chart
      ref="vchart"
      :options="option"
      theme="light"
      autoresize
      @legendselectchanged="handleLegendSelectChange"
    />
  </div>
</template>

<script>
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [userPermissionMixin],

  props: ['items', 'type', 'selectedLabels'],

  computed: {
    swapItems () {
      return this.items.reduce((acc, cur) => {
        acc.push((this.items[(this.items.length - 1) - acc.length]))
        return acc
      }, [])
    },
    option () {
      const mapLabel = {}
      if (this.getRoleMetadata.view.fields.cost) {
        mapLabel['cost'] = this.$t('message.cost')
      }
      if (this.getRoleMetadata.view.fields.discount) {
        mapLabel['discount'] = this.$t('message.discount')
      }
      if (this.getRoleMetadata.view.fields.tax) {
        mapLabel['tax'] = this.$t('message.tax')
      }
      if (this.getRoleMetadata.view.fields.collect) {
        mapLabel['collect'] = this.$t('message.collect')
      }
      if (this.getRoleMetadata.view.fields.refund) {
        mapLabel['refund'] = this.$t('message.refund')
      }
      if (this.getRoleMetadata.view.fields.net) {
        mapLabel['net'] = this.$t('message.net')
      }
      if (this.getRoleMetadata.view.fields.profit) {
        mapLabel['profit'] = this.$t('message.profit')
      }
      const legendLabels = Object.values(mapLabel)
      const series = Object.keys(mapLabel).map((key, index) => {
        return {
          name: mapLabel[key],
          type: this.type, // bar, line
          data: [
            ...this.swapItems.map((item) => item[key]),
          ],
        }
      })

      const xAxisItems = this.swapItems.map((item) => item.date)

      return {
        animation: true,
        parallel: {
          width: '100%',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: this.type === 'bar' ? 'shadow' : 'line',
          },
          formatter: (params) => {
            let html = ''
            html += `${params[0].axisValue}<br/>`
            for (const param of params) {
              html += `${param.marker} ${param.seriesName}: ${this.getNumber(param.value)}<br/>`
            }
            return html
          },
        },
        legend: {
          data: legendLabels,
          selected: {
            ...(
              (() => {
                if (Object.keys(this.selectedLabels).length) {
                  return this.selectedLabels
                }
                let defaultActive = [
                  this.getRoleMetadata.view.fields.cost ? 'cost' : null,
                  this.getRoleMetadata.view.fields.net ? 'net' : null,
                  this.getRoleMetadata.view.fields.profit ? 'profit' : null,
                ].filter((v) => v)
                if (defaultActive.length == 0) {
                  let i = 1
                  defaultActive = Object.keys(mapLabel).reduce((acc, cur) => {
                    if (i <= 3) {
                      acc.push(cur)
                    }
                    i++
                    return acc
                  }, [])
                }
                return Object.keys(mapLabel).reduce((acc, cur) => {
                  acc[mapLabel[cur]] = !!defaultActive.includes(cur)
                  return acc
                }, {})
              })()
            ),
          },
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '0%',
          containLabel: true,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            formatter: (value, index) => {
              const currency = this.$store.getters.getCurrency
              const number = this.getNumber(value)
              return `${number} ${currency}`
            },
          },
        },
        xAxis: {
          type: 'category',
          data: xAxisItems,
        },
        series: series,
      }
    },
  },

  methods: {
    handleLegendSelectChange (params) {
      this.$emit('update:selected-labels', params.selected)
    },
  },
}
</script>

<style scoped>
.chart-container /deep/ .echarts {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/ReportSaleChart.vue